export default "__VITE_ASSET__5dBicz0P__"